import { currentUser } from '@alli/frontend-common';
import getUser, { NOT_MODIFIED } from './getUser';

export default function setCurrentUser(user) {
    const finalUser = {
        ...user,
        refresh: () =>
            // no last modifed here, will force a refresh
            getUser().then(user => {
                if (user !== NOT_MODIFIED) {
                    setCurrentUser(user);
                }
            }),
    };

    currentUser.next(finalUser);
}
